import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=e40fbbbe&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=e40fbbbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40fbbbe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiBreadcrumbs: require('/app/components/UI/UiBreadcrumbs.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
